import { Button, Flex, IconChrome } from '@smarterservices/smarter-ui';
import { config } from '../../config';
import React, { useEffect } from 'react';
import StepInstructions from '../Common/StepInstructions';
//import './index.css';
import DualPane from '../DualPane';
import { checkIsOnChrome } from '../../helpers/helpers';
import { usePaneViewer } from '../PaneViewer';

const UnsupportedBrowser = ({ stepData }) => {
  const { onNext, setIsTaskComplete } = usePaneViewer();

  useEffect(() => {
    // run the browser check to confirm that indeed it is unsupported, it is possible they have switched devices for this same session...
    const isUnsupported = checkIsOnChrome();
    if (isUnsupported) {
      setIsTaskComplete(true);
      onNext();
    }
  }, []);

  return (
    <>
      {stepData && (
        <DualPane
          leftPane={
            <StepInstructions instructions={stepData?.body} />
          }
          rightPane={
            <Flex direction="column" alignItems="center">
              <Flex.Item margin="0 0 medium 0">
                <div className="chrome-colors">
                  <IconChrome size="x-large" />
                </div>
              </Flex.Item>
              <Button
                color="primary"
                size="medium"
                onClick={() => {
                  const url = config?.session?.chromeDownloadLink;
                  if (url) {
                    window.open(url, '_blank');
                  }
                }}
              >
                {stepData.button}
              </Button>
            </Flex>
          }
        />
      )}
    </>
  );
};

export default UnsupportedBrowser;
